module.exports = __webpack_public_path__ + "img/loginBgDark.123cdb4b.gif";